import React from 'react'
import { AnalyticsContext } from '../../AnalyticsContext'
import {
  EntitiesFilterModal,
  EntitiesFilterModalProps
} from '../../../../components/common/entityFiltersModals/EntitiesFilterModal'

type FilterEntityModalProps = {
  filterKey: 'groupIds' | 'pathwayIds' | 'workspaceIds' | 'campaignIds'
} & Omit<EntitiesFilterModalProps, 'selectedIds' | 'setSelectedIds'>

export const AnalyticsFilterEntityModal: React.FC<FilterEntityModalProps> = ({
  filterKey,
  ...props
}) => {
  const { filter, changeFilter } = React.useContext(AnalyticsContext)

  const setSelectedIds = React.useCallback(
    (ids: number[]) => {
      changeFilter({ [filterKey]: [...ids], page: 1 })
    },
    [changeFilter, filterKey]
  )

  return (
    <EntitiesFilterModal
      {...props}
      selectedIds={filter[filterKey] as number[]}
      setSelectedIds={setSelectedIds}
    />
  )
}
